
import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
  Button,
  DropdownToggle, DropdownMenu, DropdownItem , UncontrolledDropdown,
 } from "reactstrap";
import {
  Link
} from "react-router-dom";
import PanelHeader from "components/PanelHeader/PanelHeader.jsx";
import "assets/css/custom.css";
import ClusterService from '../../services/api/Cluster';
import { toast } from 'react-toastify';
import LoadingOverlay from 'react-loading-overlay';
import ScaleLoader from "react-spinners/ScaleLoader";
import googlecloud from "assets/img/googlecloudplatform.jpg";
import { Progress } from 'react-sweet-progress'; 
import "react-sweet-progress/lib/style.css"; 
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

class Clusters extends React.Component { 
  constructor(props) {
    super(props);
           
    this.state = {
      clusterK8sDTOS:[],
      columns:[],
      percent:'70'
      };
      this.state.columns = [
        {
        Header: 'Id',
        accessor: 'Id',
        sortable: true,
        show: false
      }, 
      {
      Header: 'Cluster Name',
      accessor: 'ClusterName',
      maxWidth: 120,
      sortable: true,
       }, 
      {
      Header: 'Description',
      accessor: 'Description',
    },
     {
      Header: 'Created By',
      accessor: 'Created',
      maxWidth: 100,
    }, {
      Header: 'Last Modified',
      accessor: 'Lastmodified',
      maxWidth: 150,
    },
    {
      Header: 'Status',
      accessor: 'Status',
      maxWidth: 100,
    },
    {
      Header: 'Monthly Usage',
      accessor: 'MonthlyUsage',
      maxWidth: 120,
    },
    {
      Header: 'Cost',
      accessor: 'Cost',
      maxWidth: 100,
    },
    {
      Header: 'Actions',
      accessor: 'Actions'
    }

  ];
  if(this.state.percent < 30){
    this.state.status= "success"
  }
  if(this.state.percent >= 30){
    this.state.status= "active"
  }
  if(this.state.percent >= 70){
    this.state.status= "error"
  }
};
  
  componentDidMount() {
   this.GetAllClusters();
  }
  GetAllClusters  = () =>{
    ClusterService.getAllClusters()
    .then((response) => {
      if (response.status === 'SUCCESS') {
        let clusterdetails = response.k8sDTOS;
        this.setState({
          clusterK8sDTOS:clusterdetails
        });
          } else {
            toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
          }
    })
  }

  viewCluster = (id) =>{
    this.props.history.push({
    pathname: 'cluster/viewcluster/'+id,
    state: { mode:"viewCluster",viewClusterId:id,}
    })
  }


 // Delete Cluster
 deleteCluster = (id) => {
  confirmAlert({
    title: <h5>Delete Cluster</h5>,
    message: 'Are you sure to delete this cluster?',
    buttons: [
      {
        label: 'Yes',
        onClick: () => this.confirmDelete(id)
      },
      {
        label: 'No',
        onClick: () => console.log('no')
      }
    ]
  });
}
confirmDelete(id) {
    ClusterService.deleteClusterById(id).then((response) => {
      if (response.status === 'SUCCESS') {
        toast.success(<i className="fas fa-check-circle">&nbsp; <b className="toast-txt">Cluster Deleted Successfully!</b></i>); 
        this.GetAllClusters();
      } else {
        toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
      }
     });
}

render() {
    return (
   
      <>
        <PanelHeader
          content={
            <div className="header text-center">           
            </div>
          }
        />
        <div className="content">
        <LoadingOverlay
      active={this.state.loading}
      spinner={<ScaleLoader
        height={35}
        width={5}
        radius={2}
        margin={2}
        color={"#123abc"}
        loading={this.state.loading}
      />}
    >
          <Row>
            <Col xs={12} md={12}>
              <Card>
                <CardHeader>
                <Row className="align-items-center">
                <div className="col">
                  <CardTitle tag="h5">Clusters</CardTitle>
                 </div>
                 <div className="col text-right">
                      <Link to="clusters" > 
                      <span> <i className="now-ui-icons loader_refresh mr-3 spin" /> </span>
                       {/* <span> <i className="fas fa-sync-alt mr-3 spin" onClick={e =>this.GetAllClusters()}/></span> */}
                      </Link>
                       <Link to={{
                        pathname: 'newclusters',
                        state: { mode: "newclusters" }
                      }}>
                         <Button
                        color="primary"
                        href="#pablo"
                        size="sm"
                      >
                    New Cluster
                      </Button>
                      </Link>
                    </div>
                </Row>
                  
                </CardHeader>
                <CardBody>
                <div className="carcontent">
                  
            <Row className="icon-examples">  

            {this.state.clusterK8sDTOS.map((item,index) => (
                <Col sm={4} xs={12} key={item.id}>
                   <Col lg="12" md="12">
                      <Card className="card-contributions hoverproject">
                        <CardBody>
                         <Row className="align-items-center">
                         <div className="col"  style={{fontSize:'12px',cursor:'pointer'}}>
                            <b style={{color: '#524848'}}>{item.name}</b>
                        </div>
                        <div className="col text-right">
                         <UncontrolledDropdown>  
                            <DropdownToggle
                            tag="span"
                                onClick={e => e.preventDefault()}
                                className="tagspan"
                            >
                             <i className="fas fa-ellipsis-v" style={{fontSize:'13px'}} />
                            </DropdownToggle>
                            <DropdownMenu 
                            right
                              className="dropdown-menu-arrow"
                            >
                              <DropdownItem onClick={e => this.deleteCluster(item.id)} 
                                href="" style={{cursor: "pointer"}}>
                              <span> 
        <i className="fas fa-trash-alt text-red mr-3" />Delete
        </span>
                              </DropdownItem>                        
                            </DropdownMenu>
            </UncontrolledDropdown>
                        </div>
                        </Row>
                        <Row><Col xs="12"> <hr></hr></Col></Row>
                        <Row style={{padding:"10px"}} onClick={e => this.viewCluster(item.id)} style={{cursor:'pointer'}}>
                        <Col xs="12" className="overflowStyle" style={{fontSize:'15px', height:'40px',cursor:'pointer'}}>
                        {item.provisionerInfoDTO.engineType === "GOOGLE_ENGINE_TYPE"}{
                         <img src={googlecloud} style={{ width: '25px', height: '25px' }}></img>
                         } &nbsp; <b style={{color: '#524848',fontSize:'14px'}}>{item.provisionerInfoDTO.name}</b>
                       </Col>
                        </Row>
                        <Row>
                        <Col xs="4" style={{fontSize:'15px', height:'50px',cursor:'pointer'}}>
                        <i className="fas fa-server"></i> &nbsp; <b style={{color: '#524848',fontSize:'12px'}}>CPU</b>
                        </Col>
                        <Col xs="8">
                        {/* <span style={{fontSize:'12px'}}>{this.state.percent}%</span> */}
                        <Progress percent={this.state.percent} status={this.state.status}
                       theme={
    {
      error: {
        symbol: this.state.percent + '%',
        trailColor: '#efefef',
        color: 'red'
      },
      default: {
        symbol: this.state.percent + '%',
        trailColor: '#efefef',
        color: 'blue'
      },
      active: {
        symbol: this.state.percent + '%',
        trailColor: '#efefef',
        color: 'orange'
      },
      success: {
        symbol: this.state.percent + '%',
        trailColor: '#efefef',
        color: 'green'
      }
    }
                          }
                        />
                       </Col>
                        </Row>
                        <Row>
                        <Col xs="4" style={{fontSize:'15px', height:'50px',cursor:'pointer'}}>
                        <i className="fas fa-memory"></i> &nbsp; <b style={{color: '#524848',fontSize:'12px'}}>Memory</b>
                        </Col>
                        <Col xs="8">
                        <Progress percent="15" status="success"
                       theme={
    {
      error: {
        symbol: '15%',
        trailColor: '#efefef',
        color: 'red'
      },
      active: {
        symbol: '15%',
        trailColor: '#efefef',
        color: 'orange'
      },
      success: {
        symbol: '15%',
        trailColor: '#efefef',
        color: 'green'
      }
    }
  }
/>
                       </Col>
                        </Row>
                        <Row>
                        <Col xs="4" style={{fontSize:'15px', height:'50px',cursor:'pointer'}}>
                        <i className="fas fa-hdd"></i>&nbsp; <b style={{color: '#524848',fontSize:'12px'}}>Disk Space</b>
                        </Col>
                        <Col xs="8">
                        <Progress percent="90" status="error"
                       theme={
    {
      error: {
        symbol: '90%',
        trailColor: '#efefef',
        color: 'red'
      },
      active: {
        symbol: '90%',
        trailColor: '#efefef',
        color: 'orange'
      },
      success: {
        symbol: '90%',
        trailColor: '#efefef',
        color: 'green'
      }
    }
  }
/>
                       </Col>
                        </Row>
                        <hr></hr>
                        <div className="text-right">
                <span className="tagspan" onClick={e => this.viewCluster(item.id)}>More <i className="fas fa-angle-double-right" ></i></span>
                </div>
                 </CardBody>
              
              </Card>
                    </Col>                                                  

                </Col>
            ))}








            </Row>
               </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          </LoadingOverlay>

        </div>
      </>
    );
  }
}

export default Clusters;